import { h } from "preact";
import { useEffect, useMemo, useRef, useState } from "preact/hooks";
import { labelPreviewUrl } from "../../api/label-creator";

export function LabelSVGInteractive(props: {
    svg?: string,
    path?: string,
    highlight?: string,
    onHover?: (id: string) => void
    maxWidth?: number,
    maxHeight?: number,
    onReload?: () => void,
    onLoad?: () => void
}) {
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const [svgUrl, setSvgUrl] = useState("");
    const [svg, setSvg] = useState(props.svg ?? null);
    const [warning, setWarning] = useState("");
    const maxWidth = props.maxWidth ?? 800;
    const maxHeight = props.maxHeight ?? 500;

    useMemo(() => {
        if (props.path) {
            fetch(labelPreviewUrl(props.path)).then(v => v.text().then(t => setSvg(t)));
        }
        else if (props.svg !== svg) {
            setSvg(props.svg ?? null);
        }
    }, [props.path, props.svg, svg]);

    useEffect(() => {
        iframeRef.current!.style.opacity = "0";

        const timeouts: ReturnType<typeof setTimeout>[] = [];
        props.onReload?.();

        if (!svg) {
            timeouts.push(setTimeout(() => {
                iframeRef.current?.contentWindow?.location.replace("about:blank");
            }, 500));
            return;
        }

        const url = URL.createObjectURL(new Blob([ svg ], { type: "image/svg+xml" }));

        timeouts.push(setTimeout(() => {
            setSvgUrl(url);

            iframeRef.current?.contentWindow?.location.replace("about:blank");

            timeouts.push(setTimeout(() => {
                iframeRef.current!.style.width = props.maxWidth + "px";
                iframeRef.current!.style.height = props.maxHeight + "px";
                iframeRef.current?.contentWindow?.location.replace(url);
            }, 500));

            timeouts.push(setTimeout(() => {
                props.onLoad?.();
                iframeRef.current!.style.opacity = "1";
            }, 700));
        }, 500));

        return () => {
            timeouts.forEach(t => clearTimeout(t));

            URL.revokeObjectURL(url);
        }
    }, [svg]);

    useEffect(() => {
        if (!props.highlight) {
            setWarning("");
            return;
        }

        const element = iframeRef.current?.contentWindow?.document?.getElementById(props.highlight);
        let lastFill = "";
        let lastStroke = "";

        if (element) {
            setWarning("");

            lastFill = element.style.fill;
            lastStroke = element.style.stroke;
            element.style.fill = "red";
            element.style.stroke = "red";
        }
        else if (props.highlight) {
            setWarning("Nie znaleziono elementu");
        }

        return () => {
            if (element) {
                element.style.fill = lastFill;
                element.style.stroke = lastStroke;
            }
        }
    }, [props.highlight])

    return <div style="position: relative">
        {warning ? <div style="position: absolute; padding-top: 2px; padding-left: 2px; background: white; border-right: 1px solid black; border-bottom: 1px solid black">
            <span class="icon tooltip tooltip-warning" style="font-size: 32px; color: var(--palette-warning-main)" data-tooltip={warning}>
                warning
            </span>
        </div> : null}
        <iframe ref={iframeRef} src="about:blank" style={{
            width: (maxWidth) + "px",
            height: (maxHeight) + "px",
            border: "none",
            overflow: "hidden",
            transition: "opacity 0.5s"
        }} onLoad={(e) => {
            const svg = e.currentTarget.contentDocument?.getElementsByTagName("svg").item(0);

            if (!svg) {
                e.currentTarget.style.height = "0px";
                return;
            }

            svg.style.background = "white";
            svg.style.overflow = "hidden";
            // svg.style.maxWidth = "800px";
            // svg.style.maxHeight = "500px";
            svg.style.width = "auto";
            svg.style.height = "auto";

            const svgStyle = e.currentTarget.contentDocument!.createElementNS("http://www.w3.org/2000/svg", "style");
            svgStyle.textContent = `
            @import url("https://fonts.googleapis.com/css?family=Roboto:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i");
            @import url("https://fonts.googleapis.com/css?family=Roboto+Mono:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i");
            @import url("https://fonts.googleapis.com/css?family=Open+Sans:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i");
            @import url("https://fonts.googleapis.com/css?family=Exo:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i");
            `;

            svg.insertBefore(svgStyle, svg.firstElementChild);

            const rect = svg.getBoundingClientRect();

            let { width, height } = rect;
            let scale = 1;

            if (width > maxWidth) {
                scale = maxWidth / width;
            }
            else if (height > maxHeight) {
                scale = maxHeight / height;
            }

            width *= scale;
            height *= scale;

            svg.style.width = width + "px";
            svg.style.height = height + "px";
            e.currentTarget.style.width = width + "px";
            e.currentTarget.style.height = height + "px";
        }}/>
    </div>;
}
